import { get } from 'lodash';

import { PayloadApiRequest } from '../actions/sagaApi';

import createResource from './createResource';
import patientsResource from './patientsResource';
import { EntityID, Insurance } from './types';

const insurancesResource = createResource<Insurance>({
  key: 'insurances',
  url: '/insurances',
  lookups: {
    patient: patientsResource,
  },
});

type UploadImageData = {
  insuranceId: EntityID;
  patientId: EntityID;
  blob: Blob;
  name: string;
  extension?: string;
  position?: 'front' | 'back';
};

const customActions = {
  uploadImage: (
    { insuranceId, patientId, blob, name, extension = 'jpg', position = 'front' }: UploadImageData,
    payload?: PayloadApiRequest<Insurance>,
  ) => {
    const data = new FormData();
    data.set('type', 'patient-insurance-image');
    data.set('patient', patientId);
    data.set('file', blob);
    data.set('name', name);
    data.set('extension', extension);
    data.set('position', position);

    return insurancesResource.request({
      url: `${insurancesResource.url}/${insuranceId}/binary`,
      method: 'post',
      data,
      headers: { 'Content-Type': 'multipart/form-data' },
      ...payload,
      meta: {
        schema: insurancesResource.schema,
        ...get(payload, 'meta'),
      },
    });
  },
};

export default {
  ...insurancesResource,
  ...customActions,
};
